module.exports = __webpack_public_path__ + "static/media/cancel-work.803d6609.png";